module.exports = __webpack_public_path__ + "static/media/logo.725aa54c.png";